import React, { useEffect, useState } from "react";
import "./Message.css";
import { Button, Card, Col, Modal, NavLink, Row } from "react-bootstrap";
import ChatBox from "./ChatBox";
import axios from "../../API/axios";
import { getConnectionList, markConversationAsRead } from "../../Services/apiService";
import { ShimmerThumbnail } from "react-shimmer-effects";
import { people } from "../../config/imagesLink";
import moment from "moment/moment";
import { Link, useNavigate, useParams } from "react-router-dom";
import MessageList from "./MessageList";
import ArchivedMessage from "./ArchivedMessage";
import { ShimmerDiv } from "@skeleton";
import CloseSharpIcon from '@mui/icons-material/CloseSharp';
import AddSharpIcon from '@mui/icons-material/AddSharp';
import MailOutlineSharpIcon from '@mui/icons-material/MailOutlineSharp';
import { useTranslation } from "react-i18next";
import SuccessToast from "../SuccessToast";
import WarningToast from "../WarningToast";
import ErrorToast from "../ErrorToast";

const Message = ({ setShowT, setNoticationDataT, showT, notificationDataT,MessagesCount }) => {
  const sessionId = localStorage.getItem("sessionId");
  const { UserId } = useParams();
  const [msgId, setMsgId] = useState("");
  const [connectionUser, setConnectionUser] = useState("");
  const [userName, setUserName] = useState("");
  const [chatList, setChatList] = useState([]);
  const { t } = useTranslation();
  //************************Message List Start  ************************//
  const [isLoading, setIsLoading] = useState(true);
  const [messageList, setmessageList] = useState("");
  const [show, setShow] = useState(false);
  const [newUser, setNewUser] = useState(false);
  const [page, setPage] = useState(1);
  const [active, setActive] = useState();
  const [archiveActive, setArchiveActive] = useState();
  const [archiveMessage, setArchiveMessage] = useState(false);
  const [allUserChats, setAllUserChats] = useState({});
  const language = localStorage.getItem("Lang");
  const [refreshChat, setRefreshChat] = useState(false);
const [toastMessage, setToastMessage] = useState("");
  const [showToast, setShowToast] = useState(false);

  const [warningToastMessage, setWarningToastMessage] = useState("");
  const [showWarningToast, setShowWarningToast] = useState(false);

  const [ErrorToastMessage, setErrorToastMessage] = useState("");
  const [showErrorToast, setShowErrorToast] = useState(false);

  const getMessageList = () => {
    const data = {
      deviceType: "Web",
      sessionId: sessionId,
    };
    axios
      .post(`Message/GetMessageList`, data)
      .then((response) => {
        setIsLoading(false);
        const res = response.data.responseData;
        console.log("GetMessageList===>", res)
        localStorage.setItem(
          "MessageChatId",
          response.data.responseData.chatID
        );

        setmessageList(res);
        if (UserId) {
          setAllUserChats((prev) => ({
            ...prev,
            [UserId]: res,
          }));
        }

        ArchivedMsgCount();
      })
      .catch((error) => {
        console.log(error);
      });
  };
  useEffect(() => {
    getMessageList();
  }, []);

  //************************Message List End  ************************//

  //************************ Connection  List Start  ************************//
  const [MsgConnectionList, setMsgConnectionList] = useState([]);
  const [searchUserName, setSearchUserName] = useState("");
  const navigate = useNavigate();
  const [unauthorisedModal, setUnauthorisedModal] = useState(false);
  const [msgSearchconnectList, setMsgSearchConnectList] = useState([])
  const [debouncedSearchM, setDebouncedSearchM] = useState(searchUserName);

  const MsgConnectionListAll = async (reset = false) => {
    const payload = {
      deviceType: "Web",
      sessionId,
      // pageNumber: page,
      pageNumber: reset ? 1 : page,
      pageSize: 10,
      type: "ConnectionList",
      search: debouncedSearchM,
            langKey: language === "en" ? "" : language,

    };

    try {
      setIsLoading(true);

      const res = await getConnectionList(payload);
      // force to array – covers null/undefined/''/object cases
      const viewListRaw = res?.data?.responseData?.viewList;
      const viewList = Array.isArray(viewListRaw) ? viewListRaw : [];

      if (debouncedSearchM !== "") {
        setMsgConnectionList([]);               // don’t mix results with search
        setMsgSearchConnectList(viewList);      // safe – always an array
      } else {
        setMsgSearchConnectList([]);
        setMsgConnectionList(prevState => {
          if (reset) return viewList;
          const prev = Array.isArray(prevState) ? prevState : [];
          const deduped = viewList.filter(
            item => !prev.some(p => p.cnctnId === item.cnctnId)
          );
          return [...prev, ...deduped];      // both sides guaranteed arrays
        });
      }
    } catch (error) {
      if ((error.code === "ERR_NETWORK" && sessionId) ||
        (error.code === "ERR_BAD_REQUEST" && sessionId)) {
        setUnauthorisedModal(true);
      }
    } finally {
      setIsLoading(false);
    }
  };

  
useEffect(() => {
  const handler = setTimeout(() => {
    setDebouncedSearchM(searchUserName);
  }, 500); // 🔹 500ms debounce delay

  return () => {
    clearTimeout(handler);
  };
}, [searchUserName]);

  useEffect(() => {
    if (show) {
      setPage(1);
      setMsgConnectionList([]);
      setMsgSearchConnectList([]);
      MsgConnectionListAll(true);   // force fresh load
    }
  }, [show]); 

  useEffect(() => {
    if (show && debouncedSearchM.trim()) {
      MsgConnectionListAll();
    }
  }, [debouncedSearchM]);
  //************************Connection List End ************************//

  const handelInfiniteScroll = async () => {
    try {
      if (
        window.innerHeight + document.documentElement.scrollTop + 1 >=
        document.documentElement.scrollHeight
      ) {
        // setLoading(true);
        setPage((prev) => prev + 1);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", handelInfiniteScroll);
    return () => window.removeEventListener("scroll", handelInfiniteScroll);
  }, []);

  const handleSendMessage = (item) => {
    const userExistsInMessageList = messageList.some(
      (message) => message.chatInfo.toUserId === item.connectsWithUserUid
    );
    if (userExistsInMessageList) {
      // Perform the action if user exists in the message list
      // console.log("User exists in the message list");
      // Call the function you need to execute when user exists
    } else {
      setChatList("");
      setConnectionUser(item.connectsWithUserUid);
      setUserName(item.connectsWithUserName);
      setShow(false);
    }
  };

  //************************Archived List Start  ************************//
  const [archivedList, setArchivedList] = useState([]);
  const getArchivedList = () => {
    const data = {
      deviceType: "Web",
      sessionId: sessionId,
      langKey: language === "en" ? "" : language,
    };
    axios
      .post(`Message/GetArchivedMessageList`, data)
      .then((response) => {

        const res = response.data.responseData; 

        setArchivedList(res);
        ArchivedMsgCount();
      })
      .catch((error) => {
        console.log(error);
      });
  };

  //************************Archived List End  ************************//

  //************************Message List Start  ************************//
  const [isLoadingChat, setIsLoadingChat] = useState(true);

  const [chatInfo, setChatInfo] = useState("");
  const [chatInfoid, setChatInfoId] = useState(null);
  // console.log('chatList', chatList);
  const getChatList = () => {
    const data = {
      deviceType: "Web",
      sessionId: sessionId,
      toUserUid: UserId,
      pageNumber: 1,
      pageSize: 32,
    };
    localStorage.setItem("toUserUid", data.toUserUid);
    axios
      // .post(`Message/GetUserChat`, data)
      .post(`Message/GetUserAllChat`, data)
      .then((response) => {
        console.log("GetUserAllChat", response.data.responseData);
        setIsLoadingChat(false);
        const res = response.data.responseData.chatList; 
        var chatId = localStorage.getItem("DeletedChatId");

        if (Array.isArray(res)) {
          setChatList(res);
          setAllUserChats(prev => ({
            ...prev,
            [UserId]: res // Store the fetched data for this user
          }));
        } else {
          console.error("chatList is not an array", res);
          setChatList([]); // prevent crashing
        }
        setChatInfo(response.data.responseData.messageInfo);
        setChatInfoId(response.data.responseData.messageInfo?.msgID);
        localStorage.setItem("msgId", response.data.responseData.messageInfo?.msgID);
        markConversationAsRead(UserId).catch((error) => {
          console.log("MarkConversationAsRead failed:", error);
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    if (UserId && UserId !== "All") {
      getChatList();
      // ReadAllChat(); 
    }
  }, [UserId]);

  // Add visibility change handler to mark messages as read when returning to tab
  useEffect(() => {
    const handleVisibilityChange = () => {
      if (!document.hidden &&
        UserId &&
        UserId !== "All" &&
        window.location.toString().includes('/Message/')) {
        // ReadAllChat();
      }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);
    window.addEventListener('focus', handleVisibilityChange);

    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
      window.removeEventListener('focus', handleVisibilityChange);
    };
  }, [UserId, chatInfo]);

  //************************Message List End  ************************//

  const [showClear, setShowClear] = useState(false);
  // const [showDelete, setShowDelete] = useState(false);

  const [activeTab, setActiveTab] = useState(1);
  const [isShown, setIsShown] = useState(true);
  //console.log('isShown', isShown);
  const renderTabContent = () => {
    switch (activeTab) {
      case 1:
        return (
          <>
            <div className="message-scroller">
              {isLoading ? (
                <div className="mt-3">
                  <ShimmerDiv height={60} width={"100%"} className="mb-2" />
                  <ShimmerDiv height={60} width={"100%"} className="mb-2" />
                  <ShimmerDiv height={60} width={"100%"} className="mb-2" />
                  <ShimmerDiv height={60} width={"100%"} className="mb-2" />
                  <ShimmerDiv height={60} width={"100%"} className="mb-2" />
                </div>
              ) : (
                messageList &&
                messageList?.map((item, index) => {
                  return (
                    <MessageList
                      // showClear={showClear}
                      // setShowClear={setShowClear}
                      isShown={isShown}
                      // showDelete={showDelete}
                      // setShowDelete={setShowDelete}
                      getChatList={getChatList}
                      item={item}
                      archiveMessage={archiveMessage}
                      index={index}
                      active={active}
                      setActive={setActive}
                      UserId={UserId}
                      setMsgId={setMsgId}
                      getArchivedList={getArchivedList}
                      getMessageList={getMessageList}
                      setIsShown={setIsShown}
                      setChatList={setChatList}
                      notificationDataT={notificationDataT}
                    />
                  );
                })
              )}
            </div>
          </>
        );
      case 2:
        return (
          <>
            <div className="message-scroller">
              {isLoading ? (
                <div className="mt-3">
                  {/* <ShimmerThumbnail height={250} rounded /> */}
                  <ShimmerDiv height={60} width={"100%"} className="mb-2" />
                  <ShimmerDiv height={60} width={"100%"} className="mb-2" />
                  <ShimmerDiv height={60} width={"100%"} className="mb-2" />
                  <ShimmerDiv height={60} width={"100%"} className="mb-2" />
                  <ShimmerDiv height={60} width={"100%"} className="mb-2" />

                </div>
              ) : (
                archivedList &&
                archivedList?.map((item, index) => {
                  return (
                    <ArchivedMessage
                      isShown={isShown}
                      getChatList={getChatList}
                      item={item}
                      archiveMessage={archiveMessage}
                      index={index}
                      archiveActive={archiveActive}
                      setArchiveActive={setArchiveActive}
                      setMsgId={setMsgId}
                      getArchivedList={getArchivedList}
                      getMessageList={getMessageList}
                      UserId={UserId}
                    />
                  );
                })
              )}
            </div>
          </>
        );
      default:
        return null;
    }
  };

  useEffect(() => {
    if (show) {
      document.body.style.overflow = 'hidden';
      document.documentElement.style.overflow = 'hidden';
      document.body.classList.add('modal-open'); // When a modal opens
    } else {
      document.body.style.overflow = 'unset';
      document.documentElement.style.overflow = '';
      document.body.classList.remove('modal-open'); // When a modal closes
    }
  }, [show]);

  // useEffect(() => {
  //   // If a userUid is present in the URL, show the message container
  //   if (UserId) {
  //     setIsShown(false); // Automatically show the message box when redirected with UserId
  //   }
  // }, [UserId]);
  // const navigate = useNavigate();
  // const handleBackToList = () => {
  //   // Navigate back to the message list by clearing userUid from the URL
  //   navigate('/Message/All');
  //   setIsShown(true)
  // };

  const [ArchdmsgCount, setArchdMsgCount] = useState(0);
  const [allmsgCount, setAllMsgCount] = useState(0);
  const ArchivedMsgCount = async () => {
    const data = {
      deviceType: "Web",
      sessionId: sessionId,
            langKey: language === "en" ? "" : language,

    };
    try {
      await axios
        .post(`Message/GetMessageCount?Archive=true`, data)
        .then((resData) => {
          //  console.log("0000000000000000000000", resData.data.responseData.allMsgslistCount);

          // if (ArchdmsgCount !== resData.data.responseData) {
          setArchdMsgCount(resData.data.responseData.archiveMsgslistCount);
          setAllMsgCount(resData.data.responseData.allMsgslistCount);
          // }
        });
    } catch (error) {
      console.log(error);
    }
  };


  // ........................read all chat ............... 

  // const ReadAllChat = async () => {
  //     const messageDetails = {
  //       deviceType: "Web",
  //       sessionId: sessionId,  
  //       msgID: chatInfo?.msgID,
  //       toUserUid: UserId,
  //     };

  //     try {
  //       const response = await axios.post("Message/ReadAllChat", messageDetails);

  //       if (response.data.success) {
  //         // Update local chat list to mark all messages as read
  //         setChatList(prevList => 
  //           prevList.map(group => ({
  //             ...group,
  //             chats: group.chats.map(chat => ({
  //               ...chat,
  //               isRead: true
  //             }))
  //           }))
  //         );

  //         // Refresh the chat list to get updated status
  //         // getChatList();

  //         // Update the UI for message list
  //         // getMessageList();
  //       }
  //     } catch (error) {
  //       console.error("Error in ReadAllChat:", error);
  //     }
  // };

  useEffect(() => {
    ArchivedMsgCount();
  }, [])

  return (
    <>
      <div
        className="row message-wrap Outermessage-wrap"
        style={{
          position: "relative",
          // zIndex: showClear || showDelete ? "2" : "1",
          zIndex: showClear ? "2" : "1",
        }}
      >
        <h4 onClick={() => setIsShown((current) => !current)} className={`${!isShown ? 'd-md-none d-block' : 'd-none'} back-button`} >  <span className="back-arrow">←</span>
        </h4>
        <div className="col-md-4 friends-list pe-lg-0 messageBoxNew">

          <Card className={`${isShown ? "d-block" : "d-md-block d-none"
            } main-card`}>
            <div
              className={`${isShown ? "d-flex" : " d-md-flex d-none"
                } chatListCont d-flex  p-3 align-items-center justify-content-between`}
            >
              <h2 className="f-20 f-600">{t("Notifications.Messages")} </h2>

              <button
                className="apply-btn newBtn d-flex align-items-center"
                onClick={() => {
                  setShow(true);
                }}
              >
                <AddSharpIcon className="material-symbols-sharp" />
                {t("Notifications.New")}
              </button>

            </div>
            <div className="tabButton d-flex p-3 w-100 ms-2 connectionTab">
              <NavLink
                onClick={() => {
                  setActiveTab(1);
                  setArchiveMessage(false);
                }}
                className={`text-center ${activeTab === 1 ? "activeTab" : ""}`}
              >
                <p className="f-14 tabName" onClick={getMessageList}>{t("Notifications.All")} ({allmsgCount})</p>
              </NavLink>

              <NavLink
                onClick={() => {
                  setActiveTab(2);
                  setArchiveMessage(true);
                }}
                className={`text-center ${activeTab === 2 ? "activeTab" : ""}`}
              >
                <p className="f-14 tabName" onClick={getArchivedList}>{t("Notifications.Archived")} ({ArchdmsgCount}) </p>
              </NavLink>
            </div>
            <div className="resume-section">{renderTabContent()}</div>
          </Card>
        </div>
        {/* {console.log("chatList", chatList, UserId)} */}

        <div
          className={`${!isShown ? "d-block" : "d-md-block d-none"
            } col-md-8 messageBox ps-0  messageBoxSecondNew`
          }
          style={{ position: "relative", zIndex: "-1" }}
        >
          {UserId === "unknown" ? (
            <div className=""></div>
          ) : (
            <ChatBox
              isShown={isShown}
              allUserChats={allUserChats}
              setAllUserChats={setAllUserChats}
              isLoadingChat={isLoadingChat}
              chatInfo={chatInfo}
              chatInfoid={chatInfoid}
              // ReadAllChat={ReadAllChat}
              getChatList={getChatList}
              userName={userName}
              chatList={chatList}
              setChatList={setChatList}
              UserId={UserId}
              msgId={msgId}
              connectionUser={connectionUser}
              getMessageList={getMessageList}
              setMsgId={setMsgId}
              setShow={setShowT}
              setNoticationData={setNoticationDataT}
              show={showT}
              notificationData={notificationDataT}
              MessagesCount={MessagesCount}
            />
          )}
        </div>
      </div>

      {show && (
        <div
          className="modal fade show postAdd"
          tabIndex="-1"
          role="dialog"
          style={{ display: "block" }}
        >
          <div className="modal-dialog  modal-dialog-centered " role="document">
            <div className="modal-content d-flex justify-content-around p-2">
              <div className="modalBorder d-flex justify-content-between align-items-center p-2">
                <h6>{t("Sidemenubar.Connections")}</h6>
                <CloseSharpIcon
                  className="material-symbols-sharp me-2 pointer"
                  onClick={() => {
                    setShow(false);
                  }}
                />
              </div>
              <Row>
                <Col md="12 notification-wrap connection-card">
                  <div className="mb-4">
                    <input
                      type="email"
                      className="form-control p-2"
                      id="exampleInputEmail1"
                      aria-describedby="emailHelp"
                      placeholder={t("People.Search user")}
                      onChange={(e) => {
                        setSearchUserName(e.target.value);
                      }}
                      value={searchUserName}
                    />
                  </div>
                  {msgSearchconnectList.length === 0
                    ? MsgConnectionList &&
                    MsgConnectionList.map((item, index) => (
                      // console.log('ConnectionList', item),
                      <Card className="mb-1 message-cards" key={index}>
                        <Card.Body className="py-1">
                          <div className="d-lg-flex d-block align-items-center justify-content-between">
                            <img
                              src={
                                item.profilPic === ""
                                  ? people.DefaultProfile
                                  : item.profilPic
                              }
                              alt=""
                              height={40}
                              width={40}
                              style={{ borderRadius: "50px" }}
                              className="Company-card-Img"
                            />
                            <div className="ms-3">
                              <h6 className="notification-message lastseen mb-1">
                                {item.fullName}
                              </h6>
                              <p className="lastseen">{item.title}</p>
                              <p className="lastseen">{item.headLine}</p>
                              <p className="lastseen">
                                {item.followersCount} {t("People.Followers")}
                              </p>
                            </div>
                            <div className="ms-auto">
                              <Link
                                to={`/Message/${item.userUid}`}
                                onClick={() => {
                                  setShow(false);
                                }}
                              >
                                <button
                                  type="submit"
                                  className="wljSecondaryBtn d-flex align-items-center"
                                >
                                  <MailOutlineSharpIcon className="material-symbols-sharp" />{" "}
                                  {t("Notifications.Message")}
                                </button>
                              </Link>
                            </div>
                          </div>
                        </Card.Body>
                      </Card>
                    ))
                    : msgSearchconnectList &&
                    msgSearchconnectList.map((item, index) => (
                      // console.log('ConnectionList', item),
                      <Card className="mb-1 message-cards" key={index}>
                        <Card.Body className="py-1">
                          <div className="d-lg-flex d-block align-items-center justify-content-between">
                            <img
                              src={
                                item.profilPic === ""
                                  ? people.DefaultProfile
                                  : item.profilPic
                              }
                              alt=""
                              height={40}
                              width={40}
                              style={{ borderRadius: "50px" }}
                              className="Company-card-Img"
                            />
                            <div className="ms-3">
                              <h6 className="notification-message mb-1">
                                {item.fullName}
                              </h6>
                              <p className="lastseen">{item.title}</p>
                              <p className="lastseen">{item.headLine}</p>
                              <p className="lastseen">
                                {item.followersCount} {t("People.Followers")}
                              </p>
                            </div>
                            <div className="ms-auto">
                              <Link
                                to={`/Message/${item.userUid}`}
                                onClick={() => {
                                  setShow(false);
                                }}
                              // onClick={() => handleSendMessage(item)}
                              >
                                <button
                                  type="submit"
                                  className="wljSecondaryBtn d-flex align-items-center"
                                >
                                  <MailOutlineSharpIcon className="material-symbols-sharp" />{" "}
                                  {t("Notifications.Message")}
                                </button>
                              </Link>
                            </div>
                          </div>
                        </Card.Body>
                      </Card>
                    ))}
                </Col>
              </Row>
            </div>
          </div>
        </div>
      )}
      {unauthorisedModal && (
        <div
          className="modal fade show postAdd"
          tabIndex="-1"
          role="dialog"
          style={{ display: "block" }}
        >
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content d-flex justify-content-around p-2">
              <div className="d-flex justify-content-between align-items-center p-2">
                <div>
                  <h4 className="text-center AdBlocker">{t("Recommendations.Warning")}</h4>
                  <p className="text-center ad-p">
                    {t("modals.Your session has expired or you are not authorized to access this resource. Please log in again to continue.")}
                  </p>
                  <div className="text-center m-auto mt-3">
                    <button
                      type="button"
                      className="mainBtn1 "
                      onClick={() => {
                        setUnauthorisedModal(!unauthorisedModal)
                        navigate("/SignIn");
                        localStorage.clear();
                        sessionStorage.removeItem('hasModalShown');
                      }}
                    >
                      {t("modals.login")} 
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {showToast && (
              <SuccessToast
                show={showToast}
                message={toastMessage}
                onClose={() => setShowToast(false)}
              />
            )}
      
            {showWarningToast && (
              <WarningToast
                show={showWarningToast}
                message={warningToastMessage}
                onClose={() => setShowWarningToast(false)}
              />
            )}
            {showErrorToast && (
              <ErrorToast
                show={showErrorToast}
                message={ErrorToastMessage}
                onClose={() => setShowErrorToast(false)}
              />
            )}
      

    </>
  );
};

export default Message;
